import { Component, computed, inject } from '@angular/core';
import { MenuDefault } from '../../types/left-menu.types';
import { BaseLeftMenuItemComponent } from '../base-left-menu-item/base-left-menu-item.component';
import { smoothShowHideHeight, smoothShowHideWidth } from '../../../../../shared/animations/smoothShowHideAnimations';
import { LeftMenuService } from "../../services/left-menu.service";
import { RouterLink } from "@angular/router";

@Component({
  selector: 'app-default-left-menu-item',
  standalone: true,
  imports: [
    RouterLink
  ],
  templateUrl: './default-left-menu-item.component.html',
  styleUrls: [
    './default-left-menu-item.component.scss',
    '../base-left-menu-item/base-left-menu-item.component.scss'
  ],
  animations: [
    smoothShowHideHeight,
    smoothShowHideWidth
  ]
})
export class DefaultLeftMenuItemComponent extends BaseLeftMenuItemComponent {
  private leftMenuService: LeftMenuService = inject(LeftMenuService);

  public menuDefault = computed(() => this.menu() as MenuDefault);

  public isMenuActive() {
    return new RegExp(`/${this.menuDefault().url.split('/').pop()}$`).test(this.router.url);
  }

  public isMenuAvailableToCurrentUser(): boolean {
    return this.leftMenuService.isMenuAvailableToCurrentUser(this.menuDefault());
  }
}
